import React, { MouseEvent } from 'react';

import { FormValues } from '@/components/pages/Users/Index/UserListForm/Container';
import { User } from '@/types/userList';
import { useVirtualizedList } from '../hooks/useVirtualizedList';
import { VirtualizedList } from '../Presentation';

type Props = {
  hasUpdateError: (userId: number) => boolean;
  isPreview: boolean;
  isUpdating: boolean;
  onCancelClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  onEditLinkClick: (e: MouseEvent<HTMLAnchorElement>, userId: number) => void;
  onUpdateUser: (values: FormValues) => Promise<void>;
  selectedUserId: number | null;
  showUserForm: (index: number) => boolean;
  users: User[];
};

export const VirtualizedListContainer: React.FC<Props> = ({
  hasUpdateError,
  isPreview,
  isUpdating,
  onCancelClick,
  onEditLinkClick,
  onUpdateUser,
  selectedUserId,
  showUserForm,
  users,
}) => {
  const { calcRowHeight, listRef, recomputeRowHeights } = useVirtualizedList(
    isPreview,
    selectedUserId,
    users,
  );

  return (
    <VirtualizedList
      calcRowHeight={calcRowHeight}
      hasUpdateError={hasUpdateError}
      isPreview={isPreview}
      isUpdating={isUpdating}
      listRef={listRef}
      onCancelClick={onCancelClick}
      onEditLinkClick={onEditLinkClick}
      onSubmit={onUpdateUser}
      recomputeRowHeights={recomputeRowHeights}
      showUserForm={showUserForm}
      users={users}
    />
  );
};
